import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, DEFINITION_KINDS, define } from '../types.js';

/**
 * Bypass auto-deactivation for Move Planner.
 */
export const schema = z.boolean();

export type AddMovesAlways = z.infer<typeof schema>;

export const definition = define({
  key: 'add_moves_always',
  schema,
  label: 'Bypass Auto-Deactivation',
  description:
    'Bypass the automatic deactivation of move planning. As mentioned in the Move Planning Activation option, move planning will deactivate automatically when a client goes over their move limit. This switch will override that behavior and allow the client to continue creating moves.',
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.MOVE_PLANNING.key,
  writableAtLevels: [LEVELS.HOPDRIVE, LEVELS.ORGANIZATION, LEVELS.CUSTOMER],
  readableByRoles: [ROLES.ADMIN, ROLES.DEALER_ADMIN, ROLES.DRIVER],
  defaultValue: true,
});
